import react, { useMemo, useState } from 'react';
import './formularios.scss'
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel';
import Card from '../../../../../components/Atomsv2/Card/Card';
import Input from '../../../../../components/Atomsv2/Input/Input';
import Select from '../../../../../components/Atomsv2/Select/Select';
import Calendar from '../../../../../components/Atomsv2/Calendar/Calendar';
import Status from '../../../../../components/Atomsv2/Status/Status';
import Text from '../../../../../components/Atomsv2/Text/Text';
import Avatar from '../../../../../components/Atomsv2/Avatar/Avatar';
import useGetDataUser from '../../../../../utilidades/customHooks/useGetDataUser';
import Button from '../../../../../components/Atomsv2/Button/Button';
import { IntegracionProyectos } from '../../integracion';
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast';
import Textarea from '../../../../../components/Atomsv2/Textarea/Textarea';

const Tarea = ({ open, onClose, data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();

    const [dataAdd, setDataAdd] = useState({
        id: null,
        tarea: null,
        descripcion: null,
        sprint: null,
        proyecto: null,
        estatus: { label: 'SIN EMPEZAR', value: 2 },
        prioridad: { label: 'MEDIA', value: 2 },
        fecha_ini: null,
        fecha_fin: null,
        usuario_asignado: null,
        usuario_creacion: null

    })
    const userData = useGetDataUser();
    const proyectos = useMemo(() => {
        return data.proyecto.map((proyecto) => ({
            value: proyecto.ID,
            label: proyecto.PROYECTO,
        }));
    }, [data.proyecto]);
    const sprints = useMemo(() => {
        return data.sprints.map((sprint) => ({
            value: sprint.ID,
            label: sprint.SPRINT,
            fecha_ini: sprint.FECHA_INI,
            fecha_fin: sprint.FECHA_FIN,
        }));
    }, [data.sprints]);
    const estatus = useMemo(() => {
        return data.estatus.map((estatus) => ({
            value: estatus.ID,
            label: estatus.ESTATUS,
        }));
    }, [data.estatus]);
    const prioridades = useMemo(() => {
        return data.prioridades.map((prioridad) => ({
            value: prioridad.ID,
            label: prioridad.PRIORIDAD,
        }));
    }, [data.prioridades]);
   
    const statusTemplate = (data) => {
        const colores = {
            1: 'default',
            2: 'warning',
            3: 'primary',
            4: 'neutral',
            5: 'success',
            6: 'error',
        }
        const color = colores[data.value] || '#6c757d';
        return (
            <Status severity={color} >{data.label}</Status>
        )
    }
    const prioridadTemplate = (data) => {
        const colores = {
            3: 'success',
            2: 'warning',
            1: 'error',
        }
        const color = colores[data.value] || '#6c757d';
        return (
            <Status severity={color} >{data.label}</Status>
        )
    }
    const sprintTemplate = (data) => {
        const fecha_ini = new Date(data.fecha_ini);
        const fecha_fin = new Date(data.fecha_fin);
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const fecha_ini_str = fecha_ini.toLocaleDateString('es-MX', options);
        const fecha_fin_str = fecha_fin.toLocaleDateString('es-MX', options);
        return (
            <div >
                <div>{data.label}</div>
                <Text size='extra-small' >{`${fecha_ini_str} - ${fecha_fin_str}`}</Text>
            </div>
        )
    }
    const submit = async () => {
        try {
            if (!dataAdd.tarea || !dataAdd.proyecto || !dataAdd.estatus || !dataAdd.prioridad || !dataAdd.fecha_ini || !dataAdd.fecha_fin) {
                addToast("Por favor, complete todos los campos", "error", 3000, 'ligth');
                return;
            }
            const nuevoId =await IntegracionProyectos.createTarea({
                tarea: dataAdd.tarea,
                descripcion: dataAdd.descripcion,
                id_area: null,
                id_proyecto: dataAdd.proyecto.value,
                estatus_id: dataAdd.estatus.value,
                prioridad_id: dataAdd.prioridad.value,
                fecha_ini: dataAdd.fecha_ini,
                fecha_fin: dataAdd.fecha_fin,
                id_sprint: dataAdd.sprint ? dataAdd.sprint.value : null,
                id_usuario_creacion: userData?.user?.ID,
                id_usuario_asignado: dataAdd.usuario_asignado?.value || null,
            });
            setData(prev => ({
                ...prev,
                tareas: [...prev.tareas, {
                    ID: nuevoId.ID,
                    TAREA: dataAdd.tarea,
                    DESCRIPCION: dataAdd.descripcion,
                    PROYECTO: dataAdd.proyecto.label,
                    PROYECTO_ID: dataAdd.proyecto.value,
                    ESTATUS: dataAdd.estatus.label,
                    ESTATUS_ID: dataAdd.estatus.value,
                    PRIORIDAD: dataAdd.prioridad.label,
                    PRIORIDAD_ID: dataAdd.prioridad.value,
                    FECHA_INI: dataAdd.fecha_ini,
                    FECHA_FIN: dataAdd.fecha_fin,
                    SPRINT: dataAdd.sprint ? dataAdd.sprint.label : null,
                    SPRINT_ID: dataAdd.sprint ? dataAdd.sprint.value : null,
                    USUARIO_CREACION_NOMBRE: userData?.user?.NOMBRE,
                    USUARIO_CREACION_ID: userData?.user?.ID,
                    USUARIO_ASIGNADO_NOMBRE: dataAdd.usuario_asignado?.label || null,
                    USUARIO_ASIGNADO_ID: dataAdd.usuario_asignado?.value || null,
                }]
            }));
            setDataAdd({
                id: null,
                tarea: null,
                descripcion: null,
                sprint: null,
                proyecto: null,
                estatus: { label: 'SIN EMPEZAR', value: 2 },
                prioridad: { label: 'MEDIA', value: 2 },
                fecha_ini: null,
                fecha_fin: null,
                usuario_asignado: null,
                usuario_creacion: null
            });
            addToast("Tarea agregada exitosamente", "success", 3000, 'ligth');
            onClose();
        }
        catch (error) {
            console.error("Error al agregar la tarea:", error);
            addToast("Error al agregar la tarea", "error", 3000, 'ligth');
        }
    }


    return (
        <SidePanel
            open={open}
            onClose={onClose}
            className={'proyecto-Tarea'}
            title="Tarea"
            icon="add_task"
            subtitle={'Crea una tarea para organizar tus proyectos'}
            width="50vw"
        >
            <Card className="tarea-card">
                <div className="tarea-header">
                    <div className="tarea-author">
                        <Avatar label={userData?.user?.NOMBRE} className="" size="small" />
                        <div className="tarea-author-info">
                            <Text weight={600} className="tarea-author-name">{userData?.user?.NOMBRE}</Text>
                        </div>
                    </div>
                    <Button icon={"add"} onClick={() => { submit() }}>Agregar</Button>
                </div>
                <Input placeholder={"NOMBRE DE LA TAREA"} className="tarea-title" label={"Tarea"} value={dataAdd.tarea} onChange={(e) => { setDataAdd(prev => ({ ...prev, tarea: prev.tarea = e.target.value })) }}></Input>
                <div className='TareaInformacionProyectos'>
                    <Select
                        label={"PROYECTO"}
                        value={dataAdd.proyecto}
                        options={proyectos}
                        onChange={(e) => {
                            setDataAdd(prev => ({ ...prev, proyecto: prev.proyecto = e }));
                        }}
                        mapper={{ name: 'label', value: 'value' }}
                    ></Select>
                    <Select
                        label={"ESTATUS"}
                        value={dataAdd.estatus}
                        options={estatus}
                        onChange={(e) => {
                            setDataAdd(prev => ({ ...prev, estatus: prev.estatus = e }));
                        }}
                        mapper={{ name: 'label', value: 'value' }}
                        body={statusTemplate}
                    ></Select>
                    <Select
                        label={"PRIORIDAD"}
                        value={dataAdd.prioridad}
                        options={prioridades}
                        onChange={(e) => {
                            setDataAdd(prev => ({ ...prev, prioridad: prev.prioridad = e }));
                        }}
                        mapper={{ name: 'label', value: 'value' }}
                        body={prioridadTemplate}
                    ></Select>
                    <Select
                        label={"ASIGNAR A"}
                        value={dataAdd.usuario_asignado}
                        options={data?.usuario}
                        onChange={(e) => {
                            setDataAdd(prev => ({ ...prev, usuario_asignado: prev.usuario_asignado = e }));
                        }}
                        mapper={{ name: 'label', value: 'value' }}
                    ></Select>
                </div>
                <div className='TareaInformacionProyectos'>
                    <Calendar onChange={(e) => { setDataAdd(prev => ({ ...prev, fecha_ini: e })) }} value={dataAdd.fecha_ini} label={"FECHA INICIO"}></Calendar>
                    <Calendar onChange={(e) => { setDataAdd(prev => ({ ...prev, fecha_fin: e })) }} value={dataAdd.fecha_fin} label={"FECHA FIN"}></Calendar>
                    <Select
                        label={"SPRINT"}
                        value={dataAdd.sprint}
                        options={sprints}
                        onChange={(e) => {
                            setDataAdd(prev => ({ ...prev, sprint: prev.sprint = e }));
                        }}
                        mapper={{ name: 'label', value: 'value' }}
                        body={sprintTemplate}
                    ></Select>
                </div>
                <Textarea
                    value={dataAdd.descripcion || ''}
                    onChange={(e) => { setDataAdd(prev => ({ ...prev, descripcion: prev.descripcion = e.target.value })) }}
                    label={"DESCRIPCIÓN"}
                    placeholder={"Agrega una descripción a la tarea..."}
                    rows={4}

                >

                </Textarea>
            </Card>
            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </SidePanel>
    )
}
export default Tarea
